import { Component, ElementRef, OnInit } from '@angular/core';
import { ProductDetailComponent } from '../../product-detail/product-detail.component';

@Component({
  selector: 'app-product-mobile-detail',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.less']
})
export class ProductDetailMobileComponent extends ProductDetailComponent {
  brandListVisible: boolean = false;
  brandList: any[] = [];


  // view / close brand list model
  handleCloseDrawer(){
    this.brandListVisible = false;
  }

  // get all brand
  getVehicleModel():void{
    let params={
      "articleId": this.productInfo?.genericArticles?.[0].legacyArticleId,
      "linkingTargetManuId": "",
      "linkingTargetType": ""
    }
    this.ecatalogService.getVehicleModel(params).subscribe((result: any) => {
      let brandList: any[] = []
      result.rtnData.forEach((item: any)=>{
        const brand = brandList.find(i=>i.name === item.manuDesc)
        if(!brand){
          brandList.push({
            name: item.manuDesc,
            active: false,
            list: [item]
          })
        }else{
          brand.list.push(item);
        }
      });
      this.brandList = brandList;
    });
  }
  handleOpenCollapse(brand: any){
    brand.active = !brand.active;
  }

  handleViewAllBrand(){
    this.getVehicleModel()
    this.brandListVisible = true;
  }

  // minus
  decrease(item: any) {
    item.quantity = (item.quantity || 0) - item.minumQty <= 0 ? 0: (item.quantity || 0) - item.minumQty;
  
  }
  // plus
  increase(item: any) {
    item.quantity = (item?.quantity || 0) + item.minumQty;
   
  }
}
